module.exports = __webpack_public_path__ + "static/media/preview.07b66703.png";